/* eslint-disable radix */
import React, { useState, useEffect } from 'react'
import { Mutation, Query } from 'react-apollo'
import { Link } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'
import {
  Row, Col, Select, message, Checkbox as CheckboxAnt,
} from 'antd'
import {
  Div, P, H3, H4, ButtonForm, Input, H5,
  Icon, SmallText,
} from 'konsys-ui'
import ReactHtmlParser from 'react-html-parser'
import QueryEditProfile from '../../components/profile'
import { Radio, Checkbox, RadioCus } from '../../components/common/choice'
import UploadFile from '../../components/common/upload'
import Container from '../../components/container'
import SummaryBox from '../../components/common/summary-detail'
import { QUOTATION_REQUEST_CREATE } from '../../constants/graph/mutation'
import {
  LIST_PAPER,
  GET_PRINTING_FORM,
  GET_QUOTATION_SUBMITTED,
  GET_TAX_RATE,
} from '../../constants/graph/query'
import PROVINCE from '../../constants/province'
import { PRINT_TECHNIQUE, PAPER } from '../../constants/detail'
import VALIDATE from '../../constants/validate'
import PATH from '../../constants/path'
import Banner from '../../images/quotation-request/banner.jpg'
import {
  WidthContainer, StepWithTitleWrapper, StepWrapper, BgContainer,
  RadioSelectWithDetailWrapper, ChoiceWrapper, ChoiceContent, ButtonWrapper,
  DetailWrapper, CustomLink, MutationResultDetailWrapper, ImgBox, MessageInputWrapper,
  MutationResultWrapper, DoneImage, CheckboxLabel, CheckboxSpan, LabelSummary,
  DescriptionDoneText, WidthContainerDonePage, ButtonFormAction, IconRequest,
} from './styled'
import { theme } from '../../styles/_variables'
import Box from '../../images/quotation-request/plain-box.png'
import { getAccessToken } from '../../utils/local-data-service'
import GraphicSelector from '../package-page/detail/components/graphic-selector'
import Summary from '../package-page/detail/components/summary'
import QuotationRequestIcon from '../../images/icon/Quotation-request Icon-01.png'


const StepWithTitle = ({ detail }) => (
  <StepWithTitleWrapper active={detail.active}>
    <P textAlign='center' margin='0 0 16px'>{detail.stepName}</P>
    <H3>{detail.stepNumber}</H3>
  </StepWithTitleWrapper>
)

const RadioSelectWithDetail = ({
  data, setDefaultChecked, defaultChecked, children,
}) => (
  <RadioSelectWithDetailWrapper>
    <Radio
      data={data}
      setDefaultChecked={value => setDefaultChecked(value)}
      defaultChecked={defaultChecked}
    />
    {
      children && <ChoiceContent isChecked={defaultChecked === data.value}>
      {
        children
      }
      </ChoiceContent>
    }
  </RadioSelectWithDetailWrapper>
)

const CheckboxSelectWithDetail = ({
  data, setDefaultChecked, checked, children,
}) => (
  <RadioSelectWithDetailWrapper>
    <Checkbox
      data={data}
      setDefaultChecked={value => setDefaultChecked(value)}
      forceChecked={checked}
    />
    {
      children && <ChoiceContent isChecked={checked}>
      {
        children
      }
      </ChoiceContent>
    }
  </RadioSelectWithDetailWrapper>
)

const step1TitleInput = {
  boxSuitDesignService: 'บริการออกแบบ',
  name: 'ชื่อ หรือ จุดประสงค์ของกล่องบรรจุภัณฑ์',
  boxSize: 'ขนาดกล่องบรรจุภัณฑ์',
  quantity: 'จำนวน',
  productQuantityPerPiece: 'จำนวนมากสุดของผลิตภัณฑ์ที่จะถูกบรรจุในกล่อง',
  paperType: 'ประเภทกระดาษ',
  paperThickness: 'ความหนากระดาษ',
  printingTechnique: 'รูปแบบการพิมพ์',
  designServiceChoice: 'บริการทำแบบ',
  productSize: 'ขนาดผลิตภัณฑ์',
  designDescription: 'รายละเอียดแนวทางการออกแบบที่ต้องการ',
  paperTypeText: 'ประเภทกระดาษ',
  printingTechniqueText: 'รูปแบบการพิมพ์',
  produceType: 'รูปแบบการสั่งผลิต',
  produceQuantity: 'จำนวนสั่งผลิต',
  price: 'ราคาบรรจุภัณฑ์',
  printingDescription: 'รายละเอียดและเทคนิคงานพิมพ์ที่ต้องการ',
  graphicType: 'บริการด้านกราฟฟิก',
}
const step2TitleInput = {
  address: 'ที่อยู่',
  name: 'ชื่อ - นามสกุล',
  email: 'Email',
  telephoneNumber: 'เบอร์โทรศัพท์',
  mobileNumber: 'เบอร์โทรศัพท์มือถือ',
  companyName: 'บริษัท (นิติบุคคล)',
  taxId: 'หมายเลขประจำตัวผู้เสียภาษี',
  detail: 'รายละเอียดเพิ่มเติม',
  companyType: 'สาขา',
  withHoldingTax: 'หักภาษี ณ ที่จ่าย',
}

/* =============================== STEP 1 ================================== */

const Step1 = ({
  data, onInputChange, onUploadFileList, onRemoveFileList,
  setDisabledButton, onDesignChoiceChange,
}) => {
  const [boxSize, setBoxSize] = useState({})
  const [productSize, setProductSize] = useState({})
  const [isValidate, setIsValidate] = useState(true)
  const paperType = PAPER.map(v => v.paper)
  return (
    <WidthContainer>
      <H3 display='block' bold margin='0 0 32px' color={theme.color.tertiaryColor}>รายละเอียดกล่องบรรจุภัณฑ์</H3>
      <H4 display='block' color={theme.color.secondaryColor}>{step1TitleInput.design}</H4>
      {/* <ChoiceWrapper id='step1-1'>
        <RadioSelectWithDetail
          data={{ value: 'notUseDesign', text: 'ไม่ต้องการใช้บริการออกแบบ', name: 'design' }}
          setDefaultChecked={value => onInputChange(value, 'boxSuitDesignService')}
          defaultChecked={data.boxSuitDesignService}
        >
          <P>สำหรับลูกค้าที่ออกแบบกล่องบรรจุภัณฑ์ด้วยตนเอง มีไฟล์แบบ หรือลวดลายพร้อมสำหรับการสั่งพิมพ์
          รูปแบบและลวดลายบนกล่องจะไม่สามารถปรับแต่งหรือแก้ไขได้</P>
        </RadioSelectWithDetail>
        <RadioSelectWithDetail
          data={{ value: 'useDesign', text: 'ต้องการใช้บริการออกแบบ', name: 'design' }}
          setDefaultChecked={value => onInputChange(value, 'boxSuitDesignService')}
          defaultChecked={data.boxSuitDesignService}
        >
          <P>สำหรับลูกค้าที่ต้องการใช้บริการออกแบบ เพื่อสร้างสรรค์กล่องบรรจุภัณฑ์ที่เหมาะสมกับผลิตภัณฑ์ของลูกค้า
          กรุณาระบุรายละเอียด และแนบไฟล์ที่ต้องการใช้ในการอ้างอิง รวมถึงรูปภาพและสัญลักษณ์ที่ต้องการใช้พิมพ์
          ลงบนกล่องผลิตภัณฑ์</P>
        </RadioSelectWithDetail>
      </ChoiceWrapper> */}
      <Div margin='24px 0'>
        <H4 display='block' margin='0 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.name} *</H4>
        <Input
          width='100%'
          value={data.name}
          onChange={(e) => {
            onInputChange(e.target.value, 'name')
            if (e.target.value !== '') {
              setDisabledButton(false)
              setIsValidate(true)
            }
          }}
          onBlur={() => {
            if (data.name === '') {
              setIsValidate(false)
              setDisabledButton(true)
            }
          }}
          state={(_.isEmpty(data.name) || !isValidate) && 'error'}
        />
      </Div>
      <Div margin='24px 0'>
        <H4 margin='0 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.boxSize}</H4>
        <Div display='flex'>
          <MessageInputWrapper width='calc((100% - 32px)/3)'>
            <Input width='100%' type='number' value={!_.isEmpty(data.boxSize) && data.boxSize.width > 0 ? data.boxSize.width : ''} message='กว้าง (ซม.)'
            onKeyPress={(e) => {
              if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault()
              }
            }}
            onChange={(e) => {
              if ((e.target.value === '' || parseFloat(e.target.value, 10) >= 0)) {
                const newBoxSize = Object.assign({}, boxSize)
                newBoxSize.w = e.target.value
                setBoxSize(newBoxSize)
                onInputChange(newBoxSize, 'boxSize')
              }
            }} />
          </MessageInputWrapper>
          <MessageInputWrapper margin='0 16px' width='calc((100% - 32px)/3)'>
            <Input type='number' value={!_.isEmpty(data.boxSize) && data.boxSize.length > 0 ? data.boxSize.length : ''} width='100%' message='ยาว (ซม.)'
            onKeyPress={(e) => {
              if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault()
              }
            }}
            onChange={(e) => {
              if ((e.target.value === '' || parseFloat(e.target.value, 10) >= 0)) {
                const newBoxSize = Object.assign({}, boxSize)
                newBoxSize.l = e.target.value
                setBoxSize(newBoxSize)
                onInputChange(newBoxSize, 'boxSize')
              }
            }} />
          </MessageInputWrapper>
          <MessageInputWrapper width='calc((100% - 32px)/3)'>
            <Input type='number' value={!_.isEmpty(data.boxSize) && data.boxSize.height > 0 ? data.boxSize.height : ''} width='100%' message='สูง (ซม.)'
            onKeyPress={(e) => {
              if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault()
              }
            }}
            onChange={(e) => {
              if ((e.target.value === '' || parseFloat(e.target.value, 10) >= 0)) {
                const newBoxSize = Object.assign({}, boxSize)
                newBoxSize.h = e.target.value
                setBoxSize(newBoxSize)
                onInputChange(newBoxSize, 'boxSize')
              }
            }} />
          </MessageInputWrapper>
        </Div>
      </Div>
      <Div margin='24px 0'>
        <H4 display='block' bold color={theme.color.primaryColor}>{step1TitleInput.quantity}</H4>
        <P display='block' margin='0 0 8px' color={theme.color.paleBlack}>ราคาต่อ 1 ชิ้นลดลง เมื่อจำนวนมากขึ้น</P>
        <Row gutter={16}>
          <Col md={8}>
            <MessageInputWrapper>
              <Input
                type='number'
                width='100%'
                message='ชิ้น'
                value={data.quantity}
                onKeyPress={e => !VALIDATE.number.test(parseInt(e.key, 10)) && e.preventDefault()}
                onChange={e => (e.target.value === '' || parseInt(e.target.value, 10) >= 0) && onInputChange(parseInt(e.target.value, 10), 'quantity')}
              />
            </MessageInputWrapper>
          </Col>
        </Row>
      </Div>
      {
        data.boxSuitDesignService === 'useDesign'
        && [
          <Div key='productSize'>
            <Div margin='24px 0'>
              <H4 margin='0 16px 8px 0' bold color={theme.color.primaryColor}>{step1TitleInput.productSize}</H4>
              <P color={theme.color.paleBlack}>( กรุณาข้าม กรณีขนาดสินค้าไม่แน่นอน )</P>
              <Div display='flex'>
                <MessageInputWrapper width='calc((100% - 32px)/3)'>
                  <Input width='100%' type='number' value={!_.isEmpty(data.productSize) && data.productSize.width > 0 ? data.productSize.width : ''} message='กว้าง (ซม.)'
                  onKeyPress={(e) => {
                    if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if ((e.target.value === '' || parseFloat(e.target.value, 10) >= 0)) {
                      const newBoxSize = Object.assign({}, productSize)
                      newBoxSize.w = e.target.value
                      setProductSize(newBoxSize)
                      onInputChange(newBoxSize, 'productSize')
                    }
                  }} />
                </MessageInputWrapper>
                <MessageInputWrapper margin='0 16px' width='calc((100% - 32px)/3)'>
                  <Input type='number' value={!_.isEmpty(data.productSize) && data.productSize.length > 0 ? data.productSize.length : ''} width='100%' message='ยาว (ซม.)'
                  onKeyPress={(e) => {
                    if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if ((e.target.value === '' || parseFloat(e.target.value, 10) >= 0)) {
                      const newBoxSize = Object.assign({}, productSize)
                      newBoxSize.l = e.target.value
                      setProductSize(newBoxSize)
                      onInputChange(newBoxSize, 'productSize')
                    }
                  }} />
                </MessageInputWrapper>
                <MessageInputWrapper width='calc((100% - 32px)/3)'>
                  <Input type='number' value={!_.isEmpty(data.productSize) && data.productSize.height > 0 ? data.productSize.height : ''} width='100%' message='สูง (ซม.)'
                  onKeyPress={(e) => {
                    if (e.charCode !== 46 && !(e.charCode >= 48 && e.charCode <= 57)) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if ((e.target.value === '' || parseFloat(e.target.value, 10) >= 0)) {
                      const newBoxSize = Object.assign({}, productSize)
                      newBoxSize.h = e.target.value
                      setProductSize(newBoxSize)
                      onInputChange(newBoxSize, 'productSize')
                    }
                  }} />
                </MessageInputWrapper>
              </Div>
            </Div>
          </Div>,
          <Div key='productTotal' margin='24px 0'>
            <H4 margin='0 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.productQuantityPerPiece}</H4>
            <Row gutter={16}>
              <Col md={8}>
                <MessageInputWrapper>
                  <Input
                    type='number'
                    width='100%'
                    message='ชิ้น'
                    value={data.productQuantityPerPiece}
                    onKeyPress={e => !VALIDATE.number.test(parseInt(e.key, 10)) && e.preventDefault()}
                    onChange={e => (e.target.value === '' || parseInt(e.target.value, 10)) >= 0 && onInputChange(parseInt(e.target.value, 10), 'productQuantityPerPiece')}
                  />
                </MessageInputWrapper>
              </Col>
            </Row>
          </Div>,
        ]
      }
      <a href={PATH.information} rel="noopener noreferrer" target="_blank">
        <DetailWrapper to={PATH.information}>
          <Icon color={theme.color.offWhite} icon='fas fa-lightbulb-exclamation' />
          <P margin='0 24px' color={theme.color.offWhite}>สามารถศึกษาข้อมูลและเทคนิคงานพิมพ์ก่อนกรอกข้อมูลด้านล่าง</P>
          <CustomLink href={PATH.information} rel="noopener noreferrer" target="_blank" bold>คลิก</CustomLink>
        </DetailWrapper>
      </a>
      <Query
        query={LIST_PAPER}
        variables={{
          limit: 10000,
          offset: 0,
        }}
      >
        {
          (props) => {
            if (props && props.data && props.data.listPaper && props.data.listPaper.success) {
              const paperData = props.data.listPaper.paper
              const paperTypes = [...paperData.map(v => ({ text: v.name, value: v.name })), { text: 'อื่นๆ', value: 'อื่นๆ' }, { text: 'ไม่ทราบ', value: 'ไม่ทราบ' }]
              const paper = [...paperData.map(v => ({
                paper: {
                  text: v.name,
                  value: v.name,
                },
                gram: v.paperThickness.map(x => x.thickness.toString()).filter((e, i, a) => a.indexOf(e) === i),
              })), { paper: { text: 'อื่นๆ', value: 'อื่นๆ' }, gram: [0] }, { paper: { text: 'ไม่ทราบ', value: 'ไม่ทราบ' }, gram: [0] }]
              return (
                <Row gutter={16}>
                  <Col sm={12} md={8}>
                    <H4 margin='24px 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.paperType}</H4>
                    <Select
                      showSearch
                      style={{ width: '100%', fontSize: '18px' }}
                      placeholder="กรุณาเลือกกระดาษ"
                      optionFilterProp="children"
                      value={data.paperTypeText}
                      onChange={value => onInputChange(value, 'paperTypeText')}
                      onBlur={() => onInputChange(((_.isNumber(data.paperTypeText) && data.paperTypeText > 0) || !_.isEmpty(data.paperTypeText))
                        && _.filter(paper, v => v.paper.value === data.paperTypeText)[0].gram[0], 'paperThickness')}
                    >
                    {
                      paperTypes.map(v => (
                        <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>
                      ))
                    }
                    </Select>
                  </Col>
                  <Col sm={12} md={8}>
                    <H4 margin='24px 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.paperThickness}</H4>
                    <Select
                      showSearch
                      style={{ width: '100%', fontSize: '18px' }}
                      placeholder="กรุณาเลือกความหนา"
                      optionFilterProp="children"
                      value={data.paperThickness}
                      onChange={value => onInputChange(value, 'paperThickness')}
                      disabled={!(data.paperTypeText && data.paperTypeText !== '') || data.paperTypeText === 'อื่นๆ' || data.paperTypeText === 'ไม่ทราบ'}
                    >
                    {
                      _.filter(paper, v => v.paper.value === data.paperTypeText).length === 1 && _.filter(paper, v => v.paper.value === data.paperTypeText)[0].gram.map(v => (
                        <Select.Option key={v} value={v}>{v}</Select.Option>
                      ))
                    }
                    </Select>
                  </Col>
                  <Col sm={24} md={8}>
                    <H4 margin='24px 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.printingTechnique}</H4>
                    <Query
                      query={GET_PRINTING_FORM}
                    >
                      {
                        (printingProps) => {
                          if (printingProps.data.getPrintingDetail) {
                            const printingData = printingProps.data.getPrintingDetail.printing
                            const resultBasicColor = printingData.printingBasicColor.map(v => ({
                              text: `พิมพ์ ${v.name}`,
                              value: `พิมพ์ ${v.name}`,
                            }))
                            const resultExtraColor = printingData.printingBasicColor.map(b => (
                              printingData.printingExtraColor.map(v => v.name).map(color => ({
                                text: `พิมพ์ ${b.name} สี + ${color}`,
                                value: `พิมพ์ ${b.name} สี + ${color}`,
                              }))
                            ))
                            const printingTechnique = [...resultBasicColor, ...resultExtraColor.reduce((a, b) => a.concat(b), []), { text: 'อื่นๆ', value: 'อื่นๆ' }, { text: 'ไม่ทราบ', value: 'ไม่ทราบ' }]
                            return (
                              <Select
                                showSearch
                                style={{ width: '100%', fontSize: '18px' }}
                                placeholder="กรุณาเลือกจำนวนสี"
                                optionFilterProp="children"
                                value={data.printingTechniqueText}
                                onChange={value => onInputChange(value, 'printingTechniqueText')}
                              >
                              {
                                printingTechnique.map(v => (
                                  <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>
                                ))
                              }
                              </Select>
                            )
                          }
                          return (
                            <Select
                              showSearch
                              style={{ width: '100%', fontSize: '18px' }}
                              placeholder="กรุณาเลือกจำนวนสี"
                              optionFilterProp="children"
                              value={data.printingTechnique}
                              onChange={value => onInputChange(value, 'printingTechnique')}
                            >
                            {
                              PRINT_TECHNIQUE.map(v => (
                                <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>
                              ))
                            }
                            </Select>
                          )
                        }
                      }
                    </Query>
                  </Col>
                </Row>
              )
            }
            return (<p>something when wrong</p>)
          }
        }
      </Query>
      <Div margin='24px 0'>
        <H4 display='block' margin='0 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.printingDescription}</H4>
        <Input as='textarea' value={data.printingDescription} rows={4} width='100%' onChange={e => onInputChange(e.target.value, 'printingDescription')} />
      </Div>
      <Div margin='24px 0'>
        <GraphicSelector
          value={data && data.graphicType}
          onChange={e => onInputChange(e, 'graphicType')}
          custom
        />
      </Div>
      {
        data.boxSuitDesignService === 'useDesign'
          ? <Div margin='24px 0'>
            <H4 display='block' margin='0 0 8px' bold color={theme.color.primaryColor}>{step1TitleInput.designDescription}</H4>
            <Input as='textarea' value={data.designDescription} rows={4} width='100%' onChange={e => onInputChange(e.target.value, 'designDescription')} />
          </Div>
          : <Div margin='24px 0'>
            <H4 display='block' margin='0 0 8px' bold color={theme.color.primaryColor}>แนบไฟล์ตัวอย่าง</H4>
            <UploadFile
              list={data.sampleFiles}
              id='uploadFileId'
              multiple
              onChange={(fileList) => {
                let upload = false
                const allowFileType = ['pdf', 'zip', '7z', 'rar', 'jpeg', 'jpg', 'png', 'psd', 'ai', 'eps', 'ppt', 'pptx', 'ppt', 'ppsx', 'ppm', 'pps', 'ppa', 'doc', 'docm', 'docx', 'dot', 'dotx']
                for (let i = 0; i < fileList.length; i += 1) {
                  const splitName = fileList[i].name.split('.')
                  if (!_.includes(allowFileType, splitName[splitName.length - 1].toLowerCase())
                  || (data.sampleFiles.length > 0 && !_.isUndefined(_.find(data.sampleFiles, d => d.name === fileList[i].name)))) {
                    upload = false
                    break
                  } else {
                    upload = true
                  }
                }
                let sameFile = false
                for (let i = 0; i < fileList.length; i += 1) {
                  if (_.find(data.sampleFiles, d => d.name === fileList[i].name)) {
                    sameFile = true
                  }
                }
                if (sameFile) {
                  message.error('ไม่สามารถอัพโหลดไฟล์ซ้ำกันได้')
                } else if (upload) {
                  onUploadFileList(fileList, 'sampleFiles')
                } else {
                  message.error('ไม่สามารถอัพโหลดไฟล์ชนิดนี้ได้')
                }
              }}
              onRemoveFile={fileName => onRemoveFileList(fileName, 'sampleFiles')}
              fileType="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, , application/pdf, image/*, .ai, .eps, .zip, .7z, .doc, .docx, .ppt, .pptx"
            />
          </Div>
      }
      {/* {
        data.boxSuitDesignService === 'useDesign'
          ? <Div margin='24px 0'>
            <H4 display='block' margin='0 0 8px' bold color={theme.color.primaryColor}>แนบไฟล์</H4>
            <UploadFile
              list={data.sampleFiles}
              id='uploadFileId'
              multiple
              onChange={(fileList) => {
                let upload = false
                const allowFileType = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'psd', 'eps', 'ai']
                for (let i = 0; i < fileList.length; i += 1) {
                  const splitName = fileList[i].name.split('.')
                  if (!_.includes(allowFileType, splitName[splitName.length - 1].toLowerCase())
                  || (data.sampleFiles.length > 0 && !_.isUndefined(_.find(data.sampleFiles, d => d.name === fileList[i].name)))) {
                    upload = false
                    break
                  } else {
                    upload = true
                  }
                }
                if (upload) {
                  onUploadFileList(fileList, 'sampleFiles')
                } else {
                  message.error('สามารถอัพโหลดได้เฉพาะไฟล์ jpg, jpeg, png, pdf และไม่สามารถอัพรูปได้')
                }
              }}
              onRemoveFile={fileName => onRemoveFileList(fileName, 'sampleFiles')}
              fileType="image/*, .pdf, .doc, .docx, .ppt, .pptx, .psd, .eps, .ai"
            />
          </Div>
          : <Div>
            <ChoiceWrapper id='step1-2'>
              <RadioSelectWithDetail
                data={{ value: 'notUseDesignService', text: 'ไม่ต้องการใช้บริการทำแบบ', name: 'designService' }}
                setDefaultChecked={value => onDesignChoiceChange(value, 'designServiceChoice')}
                defaultChecked={data.designServiceChoice}
              >
                <Div>
                  <P>สำหรับลูกค้าที่มีไฟล์แบบงานในรูปแบบนามสกุล .AI หรือ .EPS โดยภายในไฟล์แบบงานจะต้องประกอบด้วย
                  เส้นสำหรับขึ้นรูปกล่อง และลวดลายบนกล่องที่ลูกค้าออกแบบ ที่ถูกจัดวางคนละ Layer ซึ่งจะสามารถนำไปใช้ใน
                  การพิมพ์ได้โดยตรง</P>
                  <Div margin='16px 0 0'>
                    <UploadFile
                      list={data.designFiles}
                      id='uploadFileService'
                      multiple
                      onChange={(fileList) => {
                        let upload = false
                        const allowFileType = ['ai', 'eps']
                        for (let i = 0; i < fileList.length; i += 1) {
                          const splitName = fileList[i].name.split('.')
                          if (!_.includes(allowFileType, splitName[splitName.length - 1].toLowerCase())
                          || (data.designFiles.length > 0 && !_.isUndefined(_.find(data.designFiles, d => d.name === fileList[i].name)))) {
                            upload = false
                            break
                          } else {
                            upload = true
                          }
                        }
                        if (upload) {
                          onUploadFileList(fileList, 'designFiles')
                        } else {
                          message.error('สามารถอัพโหลดได้เฉพาะไฟล์ ai, eps และไม่สามารถอัพรูปได้')
                        }
                      }}
                      onRemoveFile={fileName => onRemoveFileList(fileName, 'designFiles')}
                      fileType=".ai, .eps"
                    />
                  </Div>
                </Div>
              </RadioSelectWithDetail>
              <RadioSelectWithDetail
                data={{ value: 'useDesignService', text: 'ต้องการใช้บริการทำแบบ', name: 'designService' }}
                setDefaultChecked={value => onDesignChoiceChange(value, 'designServiceChoice')}
                defaultChecked={data.designServiceChoice}
              >
                <Div>
                  <P>สำหรับลูกค้าที่ไม่มีไฟล์แบบงานในรูปแบบนามสกุล .AI หรือ .EPS ซึ่งบริการทำแบบงานจะเป็นการสรา้งไฟล์งานที่
                  ประกอบด้วย เส้นสำหรับขึ้นรูปกล่อง และลวดลายบนกล่องตามที่ลูกค้าออกแบบ เพื่อนำไปใช้ในการพิมพ์กล่อง
                  บรรจุภัณฑ์ของลูกค้าได้
                  </P>
                  <Div margin='16px 0 0'>
                    <UploadFile
                      list={data.designFiles}
                      id='uploadFileService'
                      multiple
                      onChange={(fileList) => {
                        let upload = false
                        const allowFileType = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'psd', 'eps', 'ai']
                        for (let i = 0; i < fileList.length; i += 1) {
                          const splitName = fileList[i].name.split('.')
                          if (!_.includes(allowFileType, splitName[splitName.length - 1].toLowerCase())
                          || (data.designFiles.length > 0 && !_.isUndefined(_.find(data.designFiles, d => d.name === fileList[i].name)))) {
                            upload = false
                            break
                          } else {
                            upload = true
                          }
                        }
                        if (upload) {
                          onUploadFileList(fileList, 'designFiles')
                        } else {
                          message.error('สามารถอัพโหลดได้เฉพาะไฟล์ png, jpg, jpeg, pdf และไม่สามารถอัพรูปได้')
                        }
                      }}
                      onRemoveFile={fileName => onRemoveFileList(fileName, 'designFiles')}
                      fileType="image/*, .pdf, .doc, .docx, .ppt, .pptx, .psd, .eps, .ai"
                    />
                  </Div>
                </Div>
              </RadioSelectWithDetail>
            </ChoiceWrapper>
          </Div>
      } */}
    </WidthContainer>
  )
}

/* =============================== END - STEP 1 ================================== */


/* =============================== STEP 2 ================================== */

const BoxRow = ({ children }) => (
  <Div margin='24px 0'>
    <Row gutter={16}>
    {
      children
    }
    </Row>
  </Div>
)

const TaxForm = ({
  data,
  shipAddress,
  onChangeData,
  disabledEmail,
  setWithHoldingTaxRate,
}) => (
  <Div>
    <BoxRow>
      <Col xs={24}>
        <H4 display='block' margin='0 0 8px' bold color={shipAddress ? theme.color.tertiaryColor : theme.color.primaryColor}>{step2TitleInput.name} *</H4>
      </Col>
      <Col xs={24} md={12}>
        <MessageInputWrapper>
          <Input
            width='100%'
            message='ชื่อ'
            value={data.userName}
            onChange={e => onChangeData(e.target.value, 'userName')}
            state={_.isEmpty(data.userName) && 'error'}
          />
        </MessageInputWrapper>
      </Col>
      <Col xs={24} md={12}>
        <MessageInputWrapper>
          <Input
            width='100%'
            message='นามสกุล'
            value={data.userSurname}
            onChange={e => onChangeData(e.target.value, 'userSurname')}
            state={_.isEmpty(data.userSurname) && 'error'}
          />
        </MessageInputWrapper>
      </Col>
    </BoxRow>
    <Div>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <H4 display='block' margin='24px 0 8px' bold color={shipAddress ? theme.color.tertiaryColor : theme.color.primaryColor}>{step2TitleInput.companyName}</H4>
          <Input
            width='100%'
            value={data.companyName}
            onChange={e => onChangeData(e.target.value, 'companyName')}
          />
          {
            !shipAddress
            && <Div margin='24px 0'>
              <RadioCus
                id={shipAddress ? 'shipCompanyTypeHeadquarter1' : 'companyTypeHeadquarter1'}
                name={shipAddress ? 'shipCompanyType' : 'companyType'}
                data={{ value: 'headquarter', text: 'สำนักงานใหญ่' }}
                checked={data.companyType === 'headquarter' && data.companyName}
                onChange={() => onChangeData('headquarter', 'companyType')}
                disabled={!data.companyName}
              />
              <Div alignItems='center' margin='8px 0 0'>
                <RadioCus
                  id={shipAddress ? 'shipCompanyTypeHeadquarter2' : 'companyTypeHeadquarter2'}
                  name={shipAddress ? 'shipCompanyType' : 'companyType'}
                  data={{ value: 'branch', text: 'สาขาที่' }}
                  checked={data.companyType === 'branch' && data.companyName}
                  onChange={() => onChangeData('branch', 'companyType')}
                  disabled={!data.companyName}
                />
                <Input
                  margin='0 0 0 24px'
                  value={data.branch}
                  disabled={data.companyType !== 'branch' || !data.companyName}
                  onChange={e => onChangeData(e.target.value, 'branch')}
                />
              </Div>
            </Div>
          }
        </Col>
        {
          !shipAddress
          && <Col xs={24} md={12}>
            <H4 display='block' margin='24px 0 8px' bold color={theme.color.primaryColor}>{step2TitleInput.taxId}</H4>
            <Input
              width='100%'
              value={data.taxId}
              onChange={e => onChangeData(e.target.value, 'taxId')}
            />
            <Div margin='24px 0'>
              <Query
                query={GET_TAX_RATE}
                onCompleted={(taxProps) => {
                  if (taxProps.taxRate) {
                    setWithHoldingTaxRate(taxProps.taxRate.withHoldingTaxRate)
                  }
                }}
              >
                {
                  taxPros => (
                    <CheckboxAnt
                      checked={data.withHoldingTax}
                      onChange={e => onChangeData(e.target.checked, 'withHoldingTax')}
                    >
                        <CheckboxLabel>ต้องการดำเนินการหักภาษี ณ ที่จ่าย {taxPros.data.taxRate && taxPros.data.taxRate.withHoldingTaxRate} % </CheckboxLabel><br/><CheckboxSpan>ลูกค้าจะต้องส่งหนังสือรับรองการหัก ณ ที่จ่ายตัวจริงมาให้ หลังการชำระเงิน</CheckboxSpan>
                    </CheckboxAnt>
                  )
                }
              </Query>
            </Div>
          </Col>
        }
      </Row>
    </Div>
    <Div>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <H4 display='block' margin='24px 0 8px' bold color={shipAddress ? theme.color.tertiaryColor : theme.color.primaryColor}>{step2TitleInput.telephoneNumber}</H4>
          <Input
            width='100%'
            value={data.telephoneNumber}
            onKeyPress={(e) => {
              if (!(e.charCode >= 48 && e.charCode <= 57) || e.target.value.length >= 10) {
                e.preventDefault()
              }
            }}
            onChange={e => onChangeData(e.target.value, 'telephoneNumber')}
          />
        </Col>
        <Col xs={24} md={12}>
          <H4 style={{ whiteSpace: 'nowrap' }} display='block' margin='24px 0 8px' bold color={shipAddress ? theme.color.tertiaryColor : theme.color.primaryColor}>{step2TitleInput.mobileNumber} *</H4>
          <Input
            width='100%'
            value={data.mobileNumber}
            placeholder='กรอกเฉพาะตัวเลข เช่น 0912345678'
            state={(data.mobileNumber === '' || (data.mobileNumber && data.mobileNumber.length)) !== 10 && 'error'}
            onKeyPress={(e) => {
              if (!(e.charCode >= 48 && e.charCode <= 57) || e.target.value.length >= 10) {
                e.preventDefault()
              }
            }}
            onChange={e => onChangeData(e.target.value, 'mobileNumber')}
          />
        </Col>
      </Row>
    </Div>
    <Div>
      <Row gutter={16}>
        <Col xs={24} md={24}>
          <H4 display='block' margin='24px 0 8px' bold color={shipAddress ? theme.color.tertiaryColor : theme.color.primaryColor}>{step2TitleInput.email} { !shipAddress && '*' }</H4>
          {
            !shipAddress ? <Input
              width='100%'
              value={data.email}
              onChange={e => onChangeData(e.target.value, 'email')}
              state={(_.isEmpty(data.email) || !VALIDATE.email.test(data.email)) && 'error'}
              disabled={ shipAddress ? false : disabledEmail }
            /> : <Input
              width='100%'
              value={data.email}
              onChange={e => onChangeData(e.target.value, 'email')}
              state={(!_.isEmpty(data.email) && !VALIDATE.email.test(data.email)) && 'error'}
              disabled={ shipAddress ? false : disabledEmail }
            />
          }
        </Col>
      </Row>
    </Div>
    <BoxRow>
      <Col xs={24}>
        <H4
          display='block'
          margin='0 0 8px'
          bold
          color={shipAddress ? theme.color.tertiaryColor : theme.color.primaryColor}
        >{shipAddress ? 'ที่อยู่สำหรับจัดส่ง *' : `${step2TitleInput.address} *`}</H4>
      </Col>
      <Col xs={24}>
        <MessageInputWrapper>
          <Input
            width='100%'
            message='เลขที่อยู่'
            value={data.addressNumber}
            onChange={e => onChangeData(e.target.value, 'addressNumber')}
            state={_.isEmpty(data.addressNumber) && 'error'}
          />
        </MessageInputWrapper>
      </Col>
      <Col xs={24} md={12}>
        <MessageInputWrapper>
          <Input
            width='100%'
            message='แขวง / ตำบล'
            margin='16px 0 0'
            value={data.subDistrict}
            onChange={e => onChangeData(e.target.value, 'subDistrict')}
            state={_.isEmpty(data.subDistrict) && 'error'}
          />
        </MessageInputWrapper>
      </Col>
      <Col xs={24} md={12}>
        <MessageInputWrapper>
          <Input
            width='100%'
            message='เขต / อำเภอ'
            margin='16px 0 0'
            value={data.district}
            onChange={e => onChangeData(e.target.value, 'district')}
            state={_.isEmpty(data.district) && 'error'}
          />
        </MessageInputWrapper>
      </Col>
      <Col xs={24} md={12}>
        <Div margin='16px 0 0'>
          <Select
            showSearch
            style={{ width: '100%', fontSize: '18px' }}
            placeholder="กรุณาเลือกจังหวัด"
            optionFilterProp="children"
            value={data.province}
            onChange={value => onChangeData(value, 'province')}
            className={`province ${_.isEmpty(data.province) && 'error'}`}
          >
          {
            PROVINCE.map(v => (
              <Select.Option key={v.pid} value={v.name}>{v.name}</Select.Option>
            ))
          }
          </Select>
          <SmallText color={theme.color.lightGrey} margin='8px 0 0'>จังหวัด</SmallText>
        </Div>
      </Col>
      <Col xs={24} md={12}>
        <MessageInputWrapper>
          <Input
            width='100%'
            message='รหัสไปรษณีย์'
            margin='16px 0 0'
            value={data.postalCode}
            state={(_.isEmpty(data.postalCode) || data.postalCode.length !== 5) && 'error'}
            onKeyPress={(e) => {
              if (!(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault()
              }
            }}
            onChange={(e) => {
              if (e.target.value.length <= 5) {
                onChangeData(e.target.value, 'postalCode')
              }
            }}
          />
        </MessageInputWrapper>
      </Col>
    </BoxRow>
  </Div>
)

export const Step2 = ({
  hideNotes,
  smallTitle,
  data,
  onChangeData,
  disabledEmail,
  setWithHoldingTaxRate,
}) => (
  <WidthContainer>
    {
      smallTitle
        ? <H5 display='block' bold margin='0 0 32px' color={theme.color.tertiaryColor}>รายละเอียดการออกใบกำกับภาษี</H5>
        : <H3 display='block' bold margin='0 0 32px' color={theme.color.tertiaryColor}>รายละเอียดการออกใบกำกับภาษี</H3>
    }
    <TaxForm
      data={data.taxData}
      onChangeData={(value, name) => onChangeData(value, name, 'taxData')}
      disabledEmail={disabledEmail}
      setWithHoldingTaxRate={setWithHoldingTaxRate}
    />
    <Div margin='24px 0'>
      <ChoiceWrapper id='step2'>
        <CheckboxSelectWithDetail
          data={{ value: 'newShipData', text: 'ที่อยู่สำหรับจัดส่งแตกต่างจากที่อยู่ด้านบน', name: 'newShipData' }}
          setDefaultChecked={value => onChangeData(value, 'newShipData')}
          checked={data.newShipData}
        >
          <Div>
            <TaxForm
              data={data.shipData}
              shipAddress
              onChangeData={(value, name) => onChangeData(value, name, 'shipData')}
              setWithHoldingTaxRate={setWithHoldingTaxRate}
            />
          </Div>
        </CheckboxSelectWithDetail>
      </ChoiceWrapper>
    </Div>
    {
      !hideNotes
      && <BoxRow>
        <Col xs={24}>
          <H4 display='block' margin='0 0 8px' bold color={theme.color.primaryColor}>รายละเอียดเพิ่มเติม</H4>
        </Col>
        <Col xs={24}>
          <Input
            as='textarea'
            width='100%'
            value={data.detail}
            onChange={e => onChangeData(e.target.value, 'detail')}
          />
        </Col>
      </BoxRow>
    }
  </WidthContainer>
)

/* =============================== END - STEP 2 ================================== */

const TextTitleRow = ({
  title,
  data,
  textColor,
  isMobileXL,
}) => (
  <Div>
    {
      isMobileXL ? <Div>
        <Div padding='8px 24px' margin='0 0px' bgColor={theme.color.primaryColor}>
          <H5 color={theme.color.offWhite}>{title}</H5>
        </Div>
        <Div padding='8px 24px' margin='0 0px' bgColor={theme.color.offWhite}>
          <H5 color={textColor}>{data}</H5>
        </Div>
        <br/>
      </Div> : <Div display='flex' justifyContent='space-between'>
    <Div flexBasis='35%' padding='8px 24px' margin='0px 2px 0px 0px;' bgColor={theme.color.primaryColor}>
      <H5 color={theme.color.offWhite}>{title}</H5>
    </Div>
    <Div flexBasis='75%' padding='8px 24px' margin='0 0px 0px 2px' bgColor={theme.color.offWhite}>
      <H5 color={textColor} style={{ float: 'right' }}>{data}</H5>
    </Div>
  </Div>
    }
  </Div>
)

/* =============================== STEP 3 ================================== */

export const Step3 = ({
  stepOneData,
  stepTwoData,
  isSummaryInProfile,
  isPredefined,
  formValues,
  onChangeTab,
  activeTab,
}) => {
  const stepTwoDataKey = ['taxData', 'shipData']
  const checkIsReturnValue = (value, key) => {
    if (((_.isNumber(value) && value > 0) || !_.isEmpty(value))
      && !_.isArray(value)
      && !_.isObject(value)
      && _.isUndefined(_.find(['paperType', 'printingTechnique', 'paperThickness'], v => v === key))) {
      return true
    }
    return false
  }
  const unUseValue = ['__typename',
    'status', 'width', 'length', 'height', 'adminNote', 'taxRate', 'totalPrice',
    'createdAt', 'quotationPDF', 'packageId']
  const stepOneDataList = _.reduce(_.omit(stepOneData, unUseValue), (result, value, key) => {
    if (key === 'boxSize' || key === 'productSize') {
      if (!_.isEmpty(value)) {
        result.push({ title: step1TitleInput[key], value: `${value.width} x ${value.length} x ${value.height}`, name: key })
      }
    } else if (key === 'productQuantityPerPiece') {
      if (checkIsReturnValue(value, key)) {
        result.push({ title: step1TitleInput[key], value, name: key })
      }
      if (_.filter(PAPER, d => d.paper.value === stepOneData.paperType).length > 0) {
        result.push({ title: step1TitleInput.paperType, value: `${_.filter(PAPER, d => d.paper.value === stepOneData.paperType)[0].paper.text} ${stepOneData.paperThickness} แกรม`, name: key })
      }
      if (_.filter(PRINT_TECHNIQUE, d => d.value === stepOneData.printingTechnique).length > 0) {
        result.push({ title: step1TitleInput.printingTechnique, value: _.filter(PRINT_TECHNIQUE, d => d.value === stepOneData.printingTechnique)[0].text, name: key })
      }
    } else if (key === 'sampleFiles' && !_.isEmpty(value)) {
      result.push({ title: 'ไฟล์แนบ', value, name: key })
    } else if (key === 'designFiles' && !_.isEmpty(value)) {
      result.push({ title: 'ไฟล์ทำแบบ', value, name: key })
    } else if (key === 'boxSuitDesignService') {
      // pass
    } else if (key === 'designServiceChoice') {
      // pass
    } else if (key === 'designInfo' && !_.isEmpty(value)) {
      result.push({ title: 'จำนวนผลิตภัณฑ์ที่จะบรรจุลงกล่อง', value: value.quantity, name: 'designInfo' })
    } else if (key === 'produceQuantity' && value) {
      result.push({ title: 'จำนวนสั่งผลิต', value: `${value.toLocaleString()} ชิ้น`, name: 'produceQuantity' })
    } else if (key === 'price' && value) {
      result.push({ title: 'ราคาบรรจุภัณฑ์', value: `${value.toLocaleString(undefined, { minimumFractionDigits: 2 })} บาท/ชิ้น`, name: 'price' })
    } else if (key === 'produceType' && value) {
      result.push({ title: 'รูปแบบการสั่งผลิต', value: value === 'newOrder' || value === 'สั่งผลิตใหม่' ? 'สั่งผลิตใหม่' : 'สั่งผลิตซ้ำ', name: 'produceType' })
    } else if (key === 'graphicType') {
      result.push({ title: 'บริการด้านกราฟฟิก', value: value ? value.name ? value.name : 'ไม่ใช้บริการ' : 'ไม่ใช้บริการ', name: 'graphicType' })
    } else if (checkIsReturnValue(value, key)) {
      result.push({ title: step1TitleInput[key], value, name: (key === 'printingDescription' || key === 'designDescription') ? 'detail' : key })
    }
    return result
  }, [])

  const renderDataListPredefine = (data = []) => {
    // const tmpData = data.map(value => data.name)
    const listKey = ['produceType', 'produceQuantity', 'price', 'detail', 'sampleFiles', 'graphicType']
    const resultList = []
    listKey.forEach((element) => {
      const tmp = data.findIndex(value => value.name === element)
      if (tmp > -1) {
        const result = JSON.parse(JSON.stringify(data[tmp]))
        let valueNew = <LabelSummary>{result.value}</LabelSummary>
        if (result.title === 'จำนวนสั่งผลิต' || result.title === 'ราคาบรรจุภัณฑ์') {
          const tmpValue = result.value.split(' ')
          valueNew = <span><LabelSummary>{tmpValue[0]}</LabelSummary> {tmpValue[1]}</span>
        }
        if (result.title === 'ไฟล์แนบ') {
          resultList.push({
            ...result,
          })
        } else {
          resultList.push({
            ...result,
            value: valueNew,
          })
        }
      }
    })
    return resultList
  }

  const renderDataListFreeForm = (data = []) => {
    // const tmpData = data.map(value => data.name)
    const listKey = ['name', 'boxSize', 'quantity', 'paperTypeText', 'printingTechniqueText', 'graphicType', 'detail', 'sampleFiles']
    const resultList = []
    listKey.forEach((element) => {
      const tmp = data.findIndex(value => value.name === element)
      if (tmp > -1) {
        const result = JSON.parse(JSON.stringify(data[tmp]))
        let valueNew = <LabelSummary>{result.value}</LabelSummary>
        if (result.title === 'จำนวนสั่งผลิต' || result.title === 'ราคาบรรจุภัณฑ์') {
          const tmpValue = result.value.split(' ')
          valueNew = <span><LabelSummary>{tmpValue[0]}</LabelSummary> {tmpValue[1]}</span>
        }
        if (result.title === 'ไฟล์แนบ') {
          // eslint-disable-next-line no-unused-expressions, array-callback-return
          const tmpValue = data[tmp].value.map(x => ({
            name: x.name,
            url: x.name,
          }))
          resultList.push({
            ...result,
            value: tmpValue,
          })
        } else {
          resultList.push({
            ...result,
            value: valueNew,
          })
        }
      }
    })
    return resultList
  }

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 375)
  const [isMobileXL, setIsMobileXL] = useState(window.innerWidth <= 570)
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1440)

  const screenSizeHandler = () => setIsMobileView(window.innerWidth <= 375)
  const screenSizeHandler2 = () => setIsMobileXL(window.innerWidth <= 570)
  const screenSizeHandler3 = () => setIsDesktop(window.innerWidth > 1440)
  useEffect(() => {
    window.addEventListener('resize', screenSizeHandler)
    window.addEventListener('resize', screenSizeHandler2)
    window.addEventListener('resize', screenSizeHandler3)
    return () => {
      window.removeEventListener('resize', screenSizeHandler)
      window.removeEventListener('resize', screenSizeHandler2)
      window.removeEventListener('resize', screenSizeHandler3)
    }
  }, [])

  return (
    <WidthContainer isSummaryInProfile={isSummaryInProfile}>
      {
        !isSummaryInProfile && <H3 display='block' bold margin='0 0 32px' color={theme.color.tertiaryColor}>ยืนยันการขอใบเสนอราคา</H3>
      }
      {
        !isSummaryInProfile && <Div margin='0 0 20px'>
          {/* <TextTitleRow title='หมายเลขคำขอใบเสนอราคา' data={'bs00000000100000001'} /> */}
          <TextTitleRow title='วันที่ / เวลา' data={moment().format('DD/MM/YYYY HH:mm').replace(' ', '\xa0\xa0\xa0\xa0\xa0')} isMobileXL={isMobileXL} />
        </Div>
      }
      { isPredefined && !isSummaryInProfile && <Div>
        {
          isMobileXL ? <Div>
            <Summary
              formValues={formValues}
              activeTab={activeTab}
              onChangeTab={onChangeTab}
              sticky={false}
              isFixedPosition
            />
            <br/>
            <SummaryBox
              title='รายละเอียดการสั่งผลิต'
              dataList={renderDataListPredefine(stepOneDataList)}
              isSummaryInProfile={isSummaryInProfile}
              isPredefined={isPredefined}
              isMobileXL={isMobileXL}
            />
          </Div> : <Div display='flex' justifyContent='space-between' margin="0 0 24px 0">
            <Div flexBasis='38%' margin='0px 18px 0px 0px'>
              <Summary
                formValues={formValues}
                activeTab={activeTab}
                onChangeTab={onChangeTab}
                sticky={false}
                isFixedPosition
              />
            </Div>
            <Div flexBasis='62%' margin='margin: 0 0px 0px 16px' >
              <SummaryBox
                title='รายละเอียดการสั่งผลิต'
                dataList={renderDataListPredefine(stepOneDataList)}
                isSummaryInProfile={isSummaryInProfile}
                isPredefined={isPredefined}
                isMobileXL={isMobileXL}
              />
            </Div>
          </Div>
        }
        </Div>
      }
      { isPredefined && isSummaryInProfile && isDesktop ? <Div display='flex' justifyContent='space-between' margin="0 0 24px 0">
          <Div flexBasis='100%' margin='0px 18px 0px 0px'>
            <Summary
              formValues={formValues}
              activeTab={activeTab}
              onChangeTab={onChangeTab}
              sticky={false}
              isSummaryInProfile={isSummaryInProfile}
              isFixedPosition
            />
          </Div>
          <Div flexBasis='100%' margin='margin: 0 0px 0px 16px' >
            <SummaryBox
              title='รายละเอียดการสั่งผลิต'
              dataList={renderDataListPredefine(stepOneDataList)}
              isSummaryInProfile={isSummaryInProfile}
              isPredefined={isPredefined}
              isMobileXL={isMobileXL}
            />
          </Div>
        </Div> : isPredefined && isSummaryInProfile && <Div margin="0 0 24px 0">
          <Summary
            formValues={formValues}
            activeTab={activeTab}
            onChangeTab={onChangeTab}
            sticky={false}
            isSummaryInProfile={isSummaryInProfile}
            isFixedPosition
          />
          <br/>
          <SummaryBox
            title='รายละเอียดการสั่งผลิต'
            dataList={renderDataListPredefine(stepOneDataList)}
            isSummaryInProfile={isSummaryInProfile}
            isPredefined={isPredefined}
            isMobileXL={isMobileXL}
          />
        </Div>
      }
      {
        !isPredefined && stepOneDataList.length > 0
        && <SummaryBox
          title='รายละเอียดกล่องบรรจุภัณฑ์'
          dataList={renderDataListFreeForm(stepOneDataList)}
          isSummaryInProfile={isSummaryInProfile}
          isMobileXL={isMobileXL}
        />
      }
      {
        stepTwoDataKey.map((v) => {
          const getData = _.isUndefined(stepTwoData.newShipData)
            ? stepTwoData[v]
            : (v === 'shipData' && stepTwoData.newShipData)
              ? stepTwoData.shipData
              : stepTwoData.taxData
          const dataList = _.filter(Object.keys(getData), l => l !== 'userName'
          && l !== 'userSurname'
          && l !== 'addressNumber'
          && l !== 'district'
          && l !== 'subDistrict'
          && l !== 'province'
          && l !== 'postalCode'
          && l !== 'branch'
          && l !== 'withHoldingTax'
          && l !== 'shippingDescription'
          && !_.isEmpty(getData[l])).map(d => (
            {
              title: step2TitleInput[d],
              value: d === 'companyType'
                ? _.isEmpty(getData.companyName)
                  ? null
                  : getData[d] === 'headquarter'
                    ? 'สำนักงานใหญ่'
                    : getData.branch
                : getData[d],
              name: d,
            }
          ))
          dataList.unshift({ title: `${step2TitleInput.name} ${v === 'shipData' ? 'ผู้รับ' : ''}`, value: `${getData.userName} ${getData.userSurname}`, name: 'name' })
          dataList.push({ title: step2TitleInput.address, value: `${getData.addressNumber} ${getData.subDistrict} ${getData.district} ${getData.province} ${getData.postalCode}`, name: 'address' })
          if (v === 'shipData' && (stepTwoData.shipData.shippingDescription || stepTwoData.detail)) {
            dataList.push({ title: step2TitleInput.detail, value: stepTwoData.shipData.shippingDescription ? stepTwoData.shipData.shippingDescription : stepTwoData.detail, name: 'detail' })
          }
          return (
            <SummaryBox
              key={v}
              title={v === 'taxData' ? 'รายละเอียดใบกำกับภาษี' : 'รายละเอียดการจัดส่ง'}
              dataList={dataList}
              isSummaryInProfile={isSummaryInProfile}
              isMobileXL={isMobileXL}
            />
          )
        })
      }
    </WidthContainer>
  )
}

/* =============================== END - STEP 3 ================================== */

const MutationResult = ({ quotationData, isMobileXL }) => (
  <MutationResultWrapper>
    <WidthContainerDonePage>
      <Query
        query={GET_QUOTATION_SUBMITTED}
      >
        {
          (props) => {
            const doneData = props.data
            return (
              <Div>
                {
                  isMobileXL ? <Div>
                    <MutationResultDetailWrapper>
                      <H3 display='block' bold margin='0 0 8px' color={theme.color.tertiaryColor}>ขอใบเสนอราคาเสร็จสิ้น</H3>
                      <H4 display='block' bold margin='0 0 32px' color={theme.color.tertiaryColor}>หมายเลขคำร้องขอใบเสนอราคาของคุณ คือ {quotationData.refId}</H4>
                      {
                        doneData.quotationSubmitted ? <DescriptionDoneText>
                          {ReactHtmlParser(doneData.quotationSubmitted.confirmText)}
                        </DescriptionDoneText> : <Div>
                          <H5 display='block'>เราได้รับคำขอใบเสนอราคาจากคุณแล้ว คุณจะได้รับ Email ยืนยันการขอใบเสนอราคา และจะได้รับการติดต่อจากทางเราภายในวันทำการถัดไป</H5>
                          <H5 display='block' margin='24px 0 0'>ขอบคุณที่ให้ความสนใจ boxsuit</H5>
                        </Div>
                      }
                    </MutationResultDetailWrapper>
                  </Div> : <Div display='flex' alignItems='center' padding='56px 0'>
                    <Div>
                      <ImgBox src={Box} />
                    </Div>
                    <MutationResultDetailWrapper>
                      <H3 display='block' bold margin='0 0 8px' color={theme.color.tertiaryColor}>ขอใบเสนอราคาเสร็จสิ้น</H3>
                      <H4 display='block' bold margin='0 0 32px' color={theme.color.tertiaryColor}>หมายเลขคำร้องขอใบเสนอราคาของคุณ คือ {quotationData.refId}</H4>
                      {
                        doneData.quotationSubmitted ? <DescriptionDoneText>
                          {ReactHtmlParser(doneData.quotationSubmitted.confirmText)}
                        </DescriptionDoneText> : <Div>
                          <H5 display='block'>เราได้รับคำขอใบเสนอราคาจากคุณแล้ว คุณจะได้รับ Email ยืนยันการขอใบเสนอราคา และจะได้รับการติดต่อจากทางเราภายในวันทำการถัดไป</H5>
                          <H5 display='block' margin='24px 0 0'>ขอบคุณที่ให้ความสนใจ boxsuit</H5>
                        </Div>
                      }
                    </MutationResultDetailWrapper>
                  </Div>
                }
                {
                  doneData.quotationSubmitted && <Div moreStyle={{ textAlign: 'center' }}>
                    <DoneImage src={doneData.quotationSubmitted.confirmFileUri} />
                  </Div>
                }
              </Div>
            )
          }
        }
      </Query>
      <Div margin='32px 0 0' textAlign='center' moreStyle={{ paddingBottom: '100px' }}>
        <Link to='/'>
          <ButtonForm inverse color={theme.color.secondaryColor} buttonStyle="round" text='กลับสู่หน้าแรก' />
        </Link>
      </Div>
    </WidthContainerDonePage>
  </MutationResultWrapper>
)

const QuotationRequest2 = (props) => {
  const [step, setStep] = useState(1)
  const [isPredefined, setIsPredefined] = useState(false)
  const [disabledButton, setDisabledButton] = useState(true)
  const [stepOneData, setStepOneData] = useState({
    boxSuitDesignService: 'notUseDesign',
    name: '',
    boxSize: {},
    quantity: 0,
    productSize: {},
    productQuantityPerPiece: 0,
    designDescription: '',
    printingDescription: '',
    sampleFiles: [],
    designServiceChoice: 'notUseDesignService',
    designFiles: [],
    graphicType: null,
    partDetail: [],
    totalCost: [],
    packageId: null,
  })
  const [stepTwoData, setStepTwoData] = useState({
    newShipData: props.profileData ? props.profileData.newShipData : false,
    taxData: props.profileData ? _.omit(props.profileData.address, ['addressId', '__typename']) : {},
    shipData: (props.profileData && props.profileData.newShipData) ? _.omit(props.profileData.shippingAddress, ['shippingAddressId', 'shippingDescription', 'shipping__typename', '__typename']) : {},
    detail: '',
    withHoldingTax: false,
  })
  const step2RequireField = [
    'userName',
    'userSurname',
    'email',
    'addressNumber',
    'district',
    'subDistrict',
    'province',
    'postalCode',
    'mobileNumber',
  ]
  // const [mutationSuccess, setMutationSuccess] = useState(false)
  const [quotationData, setQuotationData] = useState(null)
  const [activeTabSummary, setActiveTabSummary] = useState(0)
  const [withHoldingTaxRate, setWithHoldingTaxRate] = useState(0)

  const onChangeTab = (key) => {
    setActiveTabSummary(key)
  }

  useEffect(() => {
    const pageEntryPredefinded = props.props && props.props.location && props.props.location.search
    const tmpFormValuesPackage = localStorage.getItem('package') && JSON.parse(localStorage.getItem('package'))
    if (tmpFormValuesPackage && pageEntryPredefinded === '?predefined=true') {
      setStep(2)
      setIsPredefined(true)
      setStepOneData({
        ...stepOneData,
        packageId: tmpFormValuesPackage.partData.length > 0 ? tmpFormValuesPackage.partData[0].packageData.packageId : null,
        name: tmpFormValuesPackage.partData.length > 0 ? tmpFormValuesPackage.partData[0].packageData.name : '-',
        produceQuantity: tmpFormValuesPackage.amountProduction,
        graphicType: {
          name: tmpFormValuesPackage.graphicId.name,
        },
        sampleFiles: tmpFormValuesPackage.graphicFile.map(v => ({ uri: v.uri, name: v.name })),
        price: tmpFormValuesPackage.productionType === 'newOrder' ? tmpFormValuesPackage.priceNewOrder : tmpFormValuesPackage.priceRepeat,
        printingDescription: tmpFormValuesPackage.moreDetail,
        produceType: tmpFormValuesPackage.productionType,
        partDetail: tmpFormValuesPackage.partDetail.map(item => _.omit(item, ['__typename'])).map((item, index) => ({
          ...item,
          packagePartId: tmpFormValuesPackage.partData[index].packagePartId,
          unitSize: tmpFormValuesPackage.partData[index].measurementUnit.key,
          sizeA: tmpFormValuesPackage.partData[index].sizeList.a,
          sizeB: tmpFormValuesPackage.partData[index].sizeList.b,
          sizeC: tmpFormValuesPackage.partData[index].sizeList.c,
          sizeD: tmpFormValuesPackage.partData[index].sizeList.d,
          sizeE: tmpFormValuesPackage.partData[index].sizeList.e,
          sizeF: tmpFormValuesPackage.partData[index].sizeList.f,
          sizeG: tmpFormValuesPackage.partData[index].sizeList.g,
          sizeH: tmpFormValuesPackage.partData[index].sizeList.h,
          sizeI: tmpFormValuesPackage.partData[index].sizeList.i,
          sizeJ: tmpFormValuesPackage.partData[index].sizeList.j,
          detailActualPrinter: {
            ..._.omit(item.detailActualPrinter, ['__typename', 'maxYield']),
            paperId: tmpFormValuesPackage.partData[index].paper && tmpFormValuesPackage.partData[index].paper.paperId ? tmpFormValuesPackage.partData[index].paper.paperId : null,
          },
          detailPrintingCost: item.detailPrintingCost && {
            ..._.omit(item.detailPrintingCost, ['__typename']),
            printingBasicColorId: tmpFormValuesPackage.partData[index].printing && tmpFormValuesPackage.partData[index].printing.printingBasicColorId ? tmpFormValuesPackage.partData[index].printing.printingBasicColorId : null,
            printingExtraColor: tmpFormValuesPackage.partData[index].printing && tmpFormValuesPackage.partData[index].printing.printingExtraColorId.length > 0 ? tmpFormValuesPackage.partData[index].printing.printingExtraColorId.map(x => ({ id: x.printingExtraColorId, name: x.printingExtraColorName })) : [],
          },
          detailCoatingCost: {
            ..._.omit(item.detailCoatingCost, ['__typename']),
            coatingFrontId: tmpFormValuesPackage.partData[index].coating && tmpFormValuesPackage.partData[index].coating.coatingFrontId ? tmpFormValuesPackage.partData[index].coating.coatingFrontId : null,
            coatingBehindId: tmpFormValuesPackage.partData[index].coating && tmpFormValuesPackage.partData[index].coating.coatingBackId ? tmpFormValuesPackage.partData[index].coating.coatingBackId : null,
          },
          detailSpotUVCost: {
            ..._.omit(item.detailSpotUVCost, ['__typename']),
            spotUVFrontId: tmpFormValuesPackage.partData[index].spotUV && tmpFormValuesPackage.partData[index].spotUV.spotUVFrontId ? tmpFormValuesPackage.partData[index].spotUV.spotUVFrontId : null,
            spotUVBehindId: tmpFormValuesPackage.partData[index].spotUV && tmpFormValuesPackage.partData[index].spotUV.spotUVBackId ? tmpFormValuesPackage.partData[index].spotUV.spotUVBackId : null,
          },
          detailFoilingCost: item.detailFoilingCost ? {
            foiling: item.detailFoilingCost.foiling,
            foilingPart: item.detailFoilingCost.foilingPart.map(v => _.omit(v, ['__typename'])),
            foilingId: tmpFormValuesPackage.partData[index].foilingId ? tmpFormValuesPackage.partData[index].foilingId : null,
          } : null,
          detailGluingCost: item.detailGluingCost && {
            gluingId: tmpFormValuesPackage.partData[index].gluing ? tmpFormValuesPackage.partData[index].gluing.gluingId : null,
            gluing: tmpFormValuesPackage.partData[index].gluing ? tmpFormValuesPackage.partData[index].gluing.name : null,
          },
          detailPrinter: _.omit(item.detailPrinter, ['__typename']),
          detailSize: _.omit(item.detailSize, ['__typename']),
          detailEmbossingCost: item.detailEmbossingCost.map(v => _.omit(v, ['__typename'])),
          detailPlasticWindowCost: item.detailPlasticWindowCost.map(v => _.omit(v, ['__typename'])),
          detailAdditionalServiceCost: tmpFormValuesPackage.partData[index].additionalService.length > 0 ? tmpFormValuesPackage.partData[index].additionalService.map(x => ({ additionalServiceId: x.additionalServiceId, name: x.name })) : [],
        })),
        totalCost: tmpFormValuesPackage.totalCost.map(item => _.omit(item, ['__typename'])),
      })
      setStepTwoData({
        ...stepTwoData,
        taxData: {
          ...stepTwoData.taxData,
          withHoldingTax: tmpFormValuesPackage.widthHoldingTax,
        },
      })
    } else {
      localStorage.removeItem('package')
    }
  }, [localStorage.getItem('package'), props.props.location])

  useEffect(() => {
    if (step === 1 && stepOneData.name !== '') {
      setDisabledButton(false)
    } else if (step === 2) {
      const objectData = stepTwoData.newShipData ? ['taxData', 'shipData'] : ['taxData']
      _.each(objectData, (v) => {
        if (!_.isEmpty(stepTwoData[v])) {
          _.each(step2RequireField, (vo) => {
            if (
              _.filter(Object.keys(stepTwoData[v]), d => d === vo).length === 0
              || ((vo !== 'postalCode' || vo !== 'email') && _.isEmpty(stepTwoData[v][vo]))
              || (vo === 'postalCode' && (stepTwoData[v].postalCode === 0 || stepTwoData[v].postalCode.length !== 5))
              || (vo === 'email' && !VALIDATE.email.test(stepTwoData[v].email))
              || (vo === 'mobileNumber' && stepTwoData[v].mobileNumber.length !== 10)
            ) {
              if (v === 'shipData' && vo === 'email' && !stepTwoData[v].email) {
                setDisabledButton(false)
                return true
              }
              setDisabledButton(true)
              return false
            }
            setDisabledButton(false)
            return true
          })
        } else {
          setDisabledButton(true)
          return false
        }
        return true
      })
    }
  })

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 375)
  const [isMobileXL, setIsMobileXL] = useState(window.innerWidth <= 570)

  const screenSizeHandler = () => setIsMobileView(window.innerWidth <= 375)
  const screenSizeHandler2 = () => setIsMobileXL(window.innerWidth <= 570)

  useEffect(() => {
    window.addEventListener('resize', screenSizeHandler)
    window.addEventListener('resize', screenSizeHandler2)
    return () => {
      window.removeEventListener('resize', screenSizeHandler)
      window.removeEventListener('resize', screenSizeHandler2)
    }
  }, [])

  return (
    <Container header={{
      type: 'title',
      img: Banner,
      title: 'ขอใบเสนอราคา',
    }}>
      {
        !_.isEmpty(quotationData)
          ? <MutationResult quotationData={quotationData} isMobileXL={isMobileXL} />
          : <Mutation
            mutation={QUOTATION_REQUEST_CREATE}
          >
          {
            doCreateQuotationRequest => (
              <Div>
                <StepWrapper innerRef={(el) => { this.stepContainer = el }} current={step} >
                  <StepWithTitle
                    detail={{
                      stepNumber: 1,
                      stepName: 'กรอกรายละเอียดกล่องบรรจุภัณฑ์',
                      active: step <= 3,
                    }}
                  />
                  <StepWithTitle
                    detail={{
                      stepNumber: 2,
                      stepName: 'กรอกรายละเอียดการออกใบกำกับภาษี',
                      active: step > 1 && step <= 3,
                    }}
                  />
                  <StepWithTitle
                    detail={{
                      stepNumber: 3,
                      stepName: 'ยืนยันการขอใบเสนอราคา',
                      active: step === 3,
                    }}
                  />
                </StepWrapper>
                <BgContainer>
                  {
                    step === 1
                      ? <Step1
                        data={stepOneData}
                        onInputChange={(data, name) => {
                          const newData = Object.assign({}, stepOneData)
                          if (name === 'boxSize') {
                            newData.boxSize = {
                              width: data.w,
                              height: data.h,
                              length: data.l,
                            }
                          } else if (name === 'productSize') {
                            newData.productSize = {
                              width: data.w,
                              height: data.h,
                              length: data.l,
                            }
                          } else if (name === 'boxSuitDesignService') {
                            newData[name] = data
                            if (data === 'notUseDesign') {
                              newData.productSize = {}
                              newData.productQuantityPerPiece = 0
                              newData.designDescription = ''
                            } else {
                              newData.designFiles = []
                            }
                          } else {
                            newData[name] = data
                          }
                          setStepOneData(newData)
                        }}
                        onDesignChoiceChange={(data, name) => {
                          const newData = Object.assign({}, stepOneData)
                          newData[name] = data
                          newData.designFiles = []
                          setStepOneData(newData)
                        }}
                        onUploadFileList={(fileList, name) => {
                          const newData = Object.assign({}, stepOneData)
                          const newFileList = [...stepOneData[name]]
                          if (fileList.length >= 1) {
                            Object.keys(fileList).forEach((v) => {
                              if (v !== 'length') {
                                newFileList.push(fileList[v])
                              }
                            })
                          }
                          newData[name] = newFileList
                          setStepOneData(newData)
                        }}
                        onRemoveFileList={(fileName, name) => {
                          const newData = Object.assign({}, stepOneData)
                          const newFileList = [...stepOneData[name]]
                          _.remove(newFileList, v => v.name === fileName)
                          newData[name] = newFileList
                          setStepOneData(newData)
                        }}
                        setDisabledButton={value => setDisabledButton(value)}
                      />
                      : step === 2
                        ? <Step2
                          data={stepTwoData}
                          setWithHoldingTaxRate={setWithHoldingTaxRate}
                          disabledEmail={getAccessToken()}
                          onChangeData={(data, name, parentName) => {
                            const newData = Object.assign({}, stepTwoData)
                            if (parentName) {
                              newData[parentName][name] = data
                            } else {
                              newData[name] = data
                            }
                            if (parentName === 'taxData' && name === 'companyName' && (data === '' || data === null)) {
                              newData.taxData.branch = ''
                            }
                            if (parentName === 'shipData' && name === 'companyName' && (data === '' || data === null)) {
                              newData.shipData.branch = ''
                            }
                            setStepTwoData(newData)
                          }}
                        />
                        : <Step3
                          stepOneData={stepOneData}
                          stepTwoData={stepTwoData}
                          isPredefined={isPredefined}
                          formValues={localStorage.getItem('package') && JSON.parse(localStorage.getItem('package'))}
                          activeTab={activeTabSummary}
                          onChangeTab={onChangeTab}
                        />
                  }
                  <ButtonWrapper>
                    <ButtonFormAction disabled={step === 1} onClick={() => {
                      if (isPredefined && step === 2) {
                        props.props.history.goBack()
                      } else if (step > 1) {
                        if (this.stepContainer) {
                          this.stepContainer.scrollIntoView()
                        }
                        setStep(step - 1)
                      }
                    }} inverse color={theme.color.secondaryColor} buttonStyle="round" icon='far fa-chevron-double-left' text='ย้อนกลับ' />
                    <ButtonFormAction
                      style={{ marginLeft: '64px' }}
                      onClick={() => {
                        if (step < 3) {
                          if (this.stepContainer) {
                            this.stepContainer.scrollIntoView()
                          }
                          setStep(step + 1)
                        } else {
                          setDisabledButton(true)
                          const input = {}
                          Object.keys(stepOneData).forEach((v) => {
                            if (v !== 'boxSuitDesignService') {
                              if (v === 'boxSize' || v === 'productSize') {
                                if (!_.isEmpty(stepOneData[v])) {
                                  input[v === 'boxSize' ? 'width' : 'productWidth'] = parseFloat(stepOneData[v].width, 10)
                                  input[v === 'boxSize' ? 'length' : 'productLength'] = parseFloat(stepOneData[v].length, 10)
                                  input[v === 'boxSize' ? 'height' : 'productHeight'] = parseFloat(stepOneData[v].height, 10)
                                }
                              } else if (v === 'designServiceChoice') {
                                input.useCompleteDesign = stepOneData[v] === 'useDesignService'
                              } else if ((typeof stepOneData[v] === 'number' && stepOneData[v] > 0) || !_.isEmpty(stepOneData[v])) {
                                input[v] = stepOneData[v]
                              }
                            }
                          })
                          input.isSameAddress = !stepTwoData.newShipData
                          input.addressDescription = stepTwoData.detail
                          input.withHoldingTax = stepTwoData.taxData.withHoldingTax
                          input.withHoldingTaxRate = stepTwoData.taxData.withHoldingTax ? withHoldingTaxRate : 0
                          const stepTwoDataList = input.isSameAddress ? ['taxData'] : ['taxData', 'shipData']
                          stepTwoDataList.forEach((d) => {
                            Object.keys(stepTwoData[d]).forEach((v) => {
                              let inputName = v
                              if (v !== 'addressId' && v !== 'description' && v !== '__typename' && v !== 'withHoldingTax') {
                                if (d === 'shipData') {
                                  inputName = `shipping${v.charAt(0).toUpperCase()}${v.slice(1)}`
                                }
                                input[inputName] = stepTwoData[d][v]
                              }
                            })
                          })
                          input.isGraphic = stepOneData.graphicType ? stepOneData.graphicType.name ? stepOneData.graphicType.name : 'ไม่ใช้บริการ' : 'ไม่ใช้บริการ'
                          input.isPreDefine = isPredefined
                          input.produceType = input.produceType === 'newOrder' ? 'สั่งผลิตใหม่' : 'สั่งผลิตซ้ำ'
                          input.packageId = stepOneData.packageId || null
                          input.produceQuantity = parseInt(stepOneData.produceQuantity)
                          input.totalCost = stepOneData.totalCost.map(item => ({
                            quantity: item.quantity,
                            totalCost: item.totalCost,
                            totalRepeatCost: item.totalRepeatCost,
                          }))
                          delete input.graphicType
                          delete input.lineId
                          doCreateQuotationRequest({
                            variables: {
                              input,
                              useBoxSuitDesign: isPredefined,
                            },
                          }).then((resp) => {
                            if (!resp.loading && !_.isUndefined(resp.data)) {
                              if (!resp.data.createRequest.success) {
                                message.error(resp.data.createRequest.message)
                                setDisabledButton(false)
                              } else {
                                localStorage.removeItem('package')
                                message.success(resp.data.createRequest.message)
                                // setMutationSuccess(true)
                                setQuotationData(resp.data.createRequest.createdQuotation)
                                document.getElementById('container').scrollIntoView()
                                if (this.stepContainer) {
                                  this.stepContainer.scrollIntoView()
                                }
                              }
                            }
                          })
                        }
                      }}
                      inverse
                      color={step === 3 ? theme.color.tertiaryColor : theme.color.secondaryColor}
                      buttonStyle="round"
                      rightIcon
                      activeGreen={step === 3}
                      icon={step !== 3 ? 'far fa-chevron-double-right' : ''}
                      text={step === 3 ? <Div display='flex' alignItems='center'><IconRequest src={QuotationRequestIcon} /><span style={{ lineHeight: '17px', marginTop: '-1px' }}>ขอใบเสนอราคา</span></Div> : 'ถัดไป'}
                      disabled={disabledButton}
                    />
                  </ButtonWrapper>
                </BgContainer>
              </Div>
            )
          }
          </Mutation>
      }
    </Container>
  )
}

const QuotationRequest = (props) => {
  if (getAccessToken()) {
    return (
      <QueryEditProfile>
        <QuotationRequest2 props={props} />
      </QueryEditProfile>
    )
  }
  return (
    <QuotationRequest2 props={props} />
  )
}

export default QuotationRequest



// WEBPACK FOOTER //
// ./src/pages/quotation-request/index.jsx